module.exports = __webpack_public_path__ + "img/American-Italian.c0296b29.svg";